module.exports = __webpack_public_path__ + "media/tone.7a41e464.mp3";